module.exports = __webpack_public_path__ + "img/slot-machine.e3002fbb.png";